/* 
mock for 
Mapping > "where is your departments information"
*/
import { POPULATION_TYPE } from "@/common/models";
import { GqlMockCall } from "@/gql/lib";
import { AxisType } from "@/gql/types";
import { GqlCallsKey } from "../demo/gql.resolver";

// @ts-ignore
export const where_departments: Record<Partial<GqlCallsKey>, GqlMockCall> = {
  "departments-info.from-cloud-folders": {
    delay: 0,
    payload: async (labels: string[]) => {
      const { SharedState } = await import("@/common/state");
      return SharedState.context_labels.value
        .filter((f) => labels.includes(f.id))
        .map((l) => {
          return {
            id: l.id,
            name: l.labelName,
            count: 10,
            axis_type: AxisType.None,
            type: POPULATION_TYPE.EVENT,
          };
        });
    },
  },
};
